export enum RESPONSE_DISPLAY_TYPE {
  MULTI_SELECT_INPUT = 'MULTI_SELECT_INPUT',
  SINGLE_CHOICE_INPUT = 'SINGLE_CHOICE_INPUT',
  MULTI_CHOICES_INPUT = 'MULTI_CHOICES_INPUT',
}
